<template>
  <div class="card">
    <div class="card-body">
      <div
        class="d-flex justify-content-between align-items-center"
        :class="{ 'mb-4': hasChat }"
      >
        <div>
          <div class="avatar avatar-lg me-3">
            <i
              v-if="user.deleted_at"
              class="fa-solid fa-question d-flex justify-content-center align-items-center avatar-img rounded-circle bg-light text-primary"
            />
            <img
              v-else
              :src="avatarSrc"
              alt="User Profile Picture"
              class="avatar-img rounded-circle"
            />
          </div>
          <span class="text-subtitle">{{
            user.deleted_at ? "Paciente removido" : user.name
          }}</span>
        </div>
      </div>

      <Button
        v-if="hasChat"
        label="Falar com paciente"
        fullWidth
        outline
        @onClick="handleChat"
        leftIcon="fa-regular fa-comment-dots"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import {
  FileBaseUrl,
  type AppointmentChat,
  type AppointmentUser,
  type UserPatient,
} from "@phurshell/psiapp-frontend-core/domain";
import { UserAvatar } from "@/constants/UserAvatar";
import { useChatRoomConfigStore } from "@/store/useChatRoomConfigStore";
import { toggleModal } from "@/utils/Helper";

type ProfileUser = Pick<UserPatient, "name" | "profile_image" | "deleted_at">;
type ProfileChat = Pick<AppointmentChat, "id" | "status" | "created_at">;

const props = defineProps<{ user: ProfileUser; chat?: ProfileChat | null }>();

const avatarSrc = computed(() => {
  const img = String(props.user?.profile_image ?? "");
  return UserAvatar[img] ?? `${FileBaseUrl}${img}`;
});

const hasChat = computed(
  () =>
    !!props.chat && props.chat.status === "active" && !props.user.deleted_at,
);

function handleChat() {
  const store = useChatRoomConfigStore();
  const chat_room_config = {
    id: props.chat!.id,
    date: props.chat!.created_at,
    user_name: props.user.name,
    mode: "modal",
  };
  toggleModal("chat_room");
  store.save(chat_room_config);
}
</script>
